module.exports = __webpack_public_path__ + "media/images/icons/briefcase-0ab28d263d945c07d8a4c7d3b31dac9b.png";